// extracted by mini-css-extract-plugin
export default {"container":"JxGP","title":"D17V","actions":"XZeZ","btn":"mjXg","yes":"SHO4","no":"Avjr"};